<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="ExpandMoreFilled">
<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M6.22473 7.89137C6.46881 7.64729 6.86454 7.64729 7.10861 7.89137L10 10.7828L12.8914 7.89137C13.1355 7.64729 13.5312 7.64729 13.7753 7.89137C14.0194 8.13545 14.0194 8.53118 13.7753 8.77525L10.4419 12.1086C10.1979 12.3527 9.80214 12.3527 9.55806 12.1086L6.22473 8.77525C5.98065 8.53118 5.98065 8.13545 6.22473 7.89137Z" fill="#3751FF"/>
</g>
</svg>
